import * as React from "react";

export interface HoverChildrenProps {
  isHovered: boolean;
  ref(ref: HTMLElement | null): void;
}
export type HoverChildrenFunc = (props: HoverChildrenProps) => React.ReactNode;

interface Props {
  children: HoverChildrenFunc;
}

interface State {
  isHovered: boolean;
}

class Hover extends React.Component<Props, State> {
  public state = {
    isHovered: false,
  };

  public ref: HTMLElement | null = null;

  public componentDidMount() {
    if (this.ref) {
      this.ref.addEventListener("mouseenter", this.onMouseEnter);
      this.ref.addEventListener("mouseleave", this.onMouseLeave);
    } else {
      throw new Error("Hover: Please set ref to target component");
    }
  }

  public componentWillUnmount() {
    if (this.ref) {
      this.ref.removeEventListener("mouseenter", this.onMouseEnter);
      this.ref.removeEventListener("mouseleave", this.onMouseLeave);
    }
  }

  public onMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  public onMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  public setRef = (ref: HTMLElement | null) => {
    this.ref = ref;
  };

  public render() {
    const { children } = this.props;
    const { isHovered } = this.state;
    return children({ isHovered, ref: this.setRef });
  }
}

export default Hover;



// WEBPACK FOOTER //
// ./frontend/src/common/components/Hover.tsx